module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'exibitionfrequency'),
      expression: "sidebarCurrentPanel === 'exibitionfrequency'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.configurations')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('advanced-config-header'), _vm._v(" "), _c('advanced-config-options'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.publishAndExport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.publish')) + " " + _vm._s(_vm.$t('general.labels.and')) + " " + _vm._s(_vm.$t('general.actions.export')))])], 1)])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5dd334d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionfrequency/Main.vue
 ** module id = 838
 ** module chunks = 1
 **/